import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AssistantIcon(props: IconProps) {
    return <Icon {...props} iconKey={"assistant"}/>
}
